import { mainNavigationStyles as mainNav } from "@insite/content-library/Widgets/Header/MainNavigation";
import { StyledButton } from "@insite/mobius/Clickable";
import { IconWrapper } from "@insite/mobius/Icon";
import { StyledTypography } from "@insite/mobius/Link";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings, mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

const navHoverStyle = css`
    border-top: 1px solid ${getColor(colorStrings.primaryMain)};
    background-color: ${getColor(colorStrings.commonGlobalWhite)};
    color: ${getColor(colorStrings.primaryMain)};

    ${TypographyStyle} {
        color: ${getColor(colorStrings.primaryMain)};
        border-bottom: 0;
        text-decoration: none;
    }

    ${IconWrapper} {
        color: ${getColor(colorStrings.primaryMain)};
    }

    &::after {
        width: 77%;
        background-color: ${getColor(colorStrings.primaryMain)};
        clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 3.5px 100%);
    }

    & > ${StyledButton} {
        border-bottom: 0;

        &:hover {
            border-bottom: 0;
        }
    }
`;

const megaMenuLink = css`
    margin: 0;
    padding: 8px 20px;
    width: 100%;

    &&:hover {
        background: ${getColor(colorStrings.commonGlobalExtraLight)};
        text-decoration: underline;

        ${StyledTypography} {
            border-bottom: 0;
            text-decoration: none;
        }
    }
`;

mainNav.container = {
    css: css`
        color: ${getColor("common.background")};
        display: flex;
        justify-content: start;
    `,
};

mainNav.itemWrapper = {
    css: css`
        ${mainNav.itemWrapper?.css}

        &:first-child {
            margin-left: 0;
        }

        ${StyledButton} {
            text-decoration: none;
        }

        &:hover {
            & > ${StyledButton} {
                ${navHoverStyle}
                border-top: 0;
            }

            /* stylelint-disable-next-line selector-type-case, selector-type-no-unknown */
            & > *:not(${StyledButton}) > ${StyledButton} {
                ${navHoverStyle}
            }
        }
    `,
};

mainNav.menuItem = {
    css: css`
        ${mainNav.menuItem?.css}

        ${TypographyStyle} {
            font-weight: 500;
            display: inline-flex;
            align-items: center;
        }

        &::after {
            content: "";
            position: absolute;
            display: inline-block;
            top: 0;
            right: -1px;
            height: 6px;
            width: 0;
            transition: width 0.2s ease-in-out;
            transition-delay: 0.2s;
        }

        &:focus {
            ${navHoverStyle}
        }
    `,
};

mainNav.menuItemTypography = {
    ...mainNav.menuItemTypography,
    mergeCss: true,
    size: 18,
    transform: "none",
};

mainNav.megaMenu = {
    ...mainNav.megaMenu,
    contentBodyProps: {
        ...mainNav.megaMenu?.contentBodyProps,
        css: css`
            ${mainNav.megaMenu?.contentBodyProps?.css}
            padding: 12px 0 20px;
            max-width: calc(100vw - 40px);
        `,
    },
};

mainNav.megaMenuHeading = {
    ...mainNav.megaMenuHeading,
    css: css`
        ${mainNav.megaMenuHeading?.css}
        ${megaMenuLink}
    `,
};

mainNav.megaMenuLink = {
    ...mainNav.megaMenuLink,
    css: css`
        ${mainNav.megaMenuLink?.css}
        ${megaMenuLink}
    `,
};

mainNav.megaMenuGridContainer = {
    ...mainNav.megaMenuGridContainer,
    gap: 0,
};

mainNav.mobileSearchButton = {
    variant: "tertiary",
    mergeCss: true,
    size: 50,
    color: colorStrings.primaryMain,
    buttonType: "solid",
    css: css`
        padding: 0;

        &&&:hover {
            background-color: ${getColor(colorStrings.primaryMain)};
            border-color: ${getColor(colorStrings.primaryMain)};
        }
    `,
};

mainNav.mobileSearchModal = {
    ...mainNav.mobileSearchModal,
    cssOverrides: {
        ...mainNav.mobileSearchModal?.cssOverrides,
        modalTitle: css`
            ${mainNav.mobileSearchModal?.cssOverrides?.modalTitle}

            & > [class*="OverflowWrapper-"] > [class*="PopoverStyle-"] {
                /* stylelint-disable-next-line */
                height: calc(100dvh - 60px) !important;
                top: 60px !important;
            }
        `,
    },
    closeButtonProps: {
        variant: "tertiary",
        mergeCss: true,
        shape: "rectangle",
        color: colorStrings.secondaryMain,
        buttonType: "outline",
        css: css`
            &&& {
                background-color: transparent;
                border-color: transparent;
                mix-blend-mode: initial;
            }
        `,
    },
};

mainNav.mobileSearchModal = {
    ...mainNav.mobileSearchModal,
    closeButtonProps: {
        ...mainNav.mobileSearchModal.closeButtonProps,
        css: css`
            ${mainNav.mobileSearchModal.closeButtonProps?.css}
            padding: 0 5px;
            margin-left: 10px;
        `,
    },
    cssOverrides: {
        ...mainNav.mobileSearchModal.cssOverrides,
        modalBody: css`
            ${mainNav.mobileSearchModal.cssOverrides?.modalBody}
            &&& {
                ${mediaQueriesBP.maxMD} {
                    height: 100%;
                    margin: 0;
                    max-height: 100%;
                }
            }
        `,
        modalTitle: css`
            ${mainNav.mobileSearchModal.cssOverrides?.modalTitle}
            &&& {
                background-color: transparent;
            }
        `,
    },
};
